<template>
  <v-sheet class="bg-surface-light py-16">
    <v-container>
      <TitleParagraphRow :value="value" />

      <template v-if="value.items && value.items.length">
        <v-row v-for="(item, i) in value.items" :key="item.id">
          <v-col>
            <v-card rounded="0">
              <PackageOverviewItem
                :opposite="i % 2 ? true : false"
                :value="item"
              />
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-container>
  </v-sheet>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
